/* eslint-disable import/prefer-default-export */
const { REACT_APP_SEGMENT_WRITE_KEY } = process.env;

const track = (obj) => {
    if (REACT_APP_SEGMENT_WRITE_KEY && REACT_APP_SEGMENT_WRITE_KEY !== '-') {
        const { event, properties } = obj;
        return window.analytics.track(event, properties);
    }
    return obj;
};

const identify = (id) => {
    return window.analytics.identify(id);
};

const analytics = {
    track,
    identify,
};

export { analytics };
